<template>
  <div class="form-group"
       :class="[
       {'input-group': hasIcon},
       {'has-danger': error},
       {'input-group-focus': focused},
       {'has-label': label || $slots.label},
       {'has-success': !error && touched}]">
    <slot name="label">
      <label v-if="label" :class="labelClasses">
        {{label}}
        <span v-if="required" class="required">*</span>
        <span v-if="priced" class="priced">₹</span>
        <small class="text-muted help-text" style="margin-left:5px">{{ description }}</small>
      </label>
    </slot>
    <slot name="addonLeft">
      <div v-if="addonLeftIcon" class="input-group-addon input-group-prepend">
        <i :class="addonLeftIcon"></i>
      </div>
    </slot>
    <slot>
      <input
        v-if="type != 'textarea'"
        :type="type"
        :value="value"
        v-on="listeners"
        v-bind="$attrs"
        :placeholder="(placeholder) ? (required) ? `${placeholder} (required)`: placeholder : (required) ? `${label} (required)`: label"
        class="form-control"
        :class="[{valid: value && !error}, inputClasses]"
        aria-describedby="addon-right addon-left">
        <textarea 
          v-if="type == 'textarea'" 
          :rows="rows"
          :value="value"
          v-on="listeners"
          v-bind="$attrs"
          class="form-control"
          :class="[{valid: value && !error}, inputClasses]"
          aria-describedby="addon-right addon-left"></textarea>
    </slot>
    <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-addon input-group-append">
          <i :class="addonRightIcon"></i>
        </span>
    </slot>

    <slot name="infoBlock"></slot>
    <slot name="helpBlock">
      <div class="text-danger invalid-feedback" style="display: block;" :class="{'mt-2': hasIcon}" v-if="error">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'fg-input',
  props: {
    required: Boolean,
    priced: Boolean,
    label: String,
    error: String,
    labelClasses: String,
    inputClasses: String,
    value: {
      type: [String, Number, Boolean, Array, Date, Object],
      default: ''
    },
    addonRightIcon: String,
    addonLeftIcon: String,
    type: String,
    rows: Number,
    description: String,
    placeholder: String,
  },
  data() {
    return {
      touched: false,
      focused: false
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    }
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      if (!this.touched && value) {
        this.touched = true;
      }
      this.$emit('input', value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit('focus', value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit('blur', value);
    }
  }
};
</script>
<style>
  input.form-control{
    height: fit-content!important;
  }
  label span{
    margin-right: 5px;
  }

  label span.required{
    color: #c0392b;
  }
  label span.priced{
    color: #27ae60;
  }

  .form-group textarea.form-control{
    border: solid 1px #ccc;
    background-color: transparent;
    border: 1px solid #E3E3E3;
    border-radius: 10px;
    color: #2c2c2c;
    line-height: normal;
    font-size: 0.8571em;
    -webkit-transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out, background-color 0.3s ease-in-out;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .form-group textarea.form-control:focus{
    border: 1px solid #273c75;
    -webkit-box-shadow: none;
    box-shadow: none;
    outline: 0 !important;
    color: #2c2c2c;
  }
  .form-group label{
    line-height: 5px;
  }
</style>
